export default __webpack_public_path__ + "static/media/INFINITILogoWhite.26778d52.png";